export default __webpack_public_path__ + "static/media/Rectangle152@2x.143728b4.png";